import { RgbColorPicker } from 'react-colorful';
import styled from 'styled-components';

const StyledColorPickerContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 380px;
	border-radius: 10px;
	overflow: hidden;
	isolation: isolate;

	transition: height 0.25s ease;
`;

const StyledColorPicker = styled(RgbColorPicker).attrs({ tabIndex: 0 })`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100% !important;
	height: 280px !important;

	.react-colorful__saturation {
		height: 240px !important;
		border-radius: 10px !important;
		border: initial !important;

		.react-colorful__interactive {
			left: 10px;
			top: 10px;
			width: calc(100% - 20px);
			height: calc(100% - 20px);
		}
	}

	.react-colorful__hue {
		width: 100%;
		height: 20px !important;
		border-radius: 6px !important;

		.react-colorful__interactive {
			left: 10px;
			width: calc(100% - 20px);
		}
	}

	.react-colorful__pointer {
		width: 10px !important;
		height: 10px !important;
		padding: 5px;
		background-clip: content-box;
		box-shadow: initial !important;
		border: 5px solid rgba(0, 0, 0, 0.25) !important;

		.react-colorful__pointer-fill {
			background-color: white !important;
		}

		outline: none !important;
	}

	.react-colorful__interactive:focus .react-colorful__pointer {
		transform: translate(-50%, -50%) !important;
	}
`;

export { StyledColorPickerContainer, StyledColorPicker };
